export default "__VITE_ASSET__D4x9vwZ5__"